import { useEffect } from 'react';
import { 
    listenMonitor,
    sendInitialDataStart,
    sendInitialDataDone
} from '../../channels/monitorChannel';
import { sendClients } from '../../channels/clientsChannel';
import { useClientsStore } from '../../stores/useClientsStore';

import { sendVehicles, sendVehiclesSelectedTrips } from '../../channels/vehiclesChannel';
import { useVehiclesStore } from '../../stores/useVehiclesStore';

import { sendDrivers, sendDriversSelectedTrips } from '../../channels/driversChannel';
import { useDriversStore } from '../../stores/useDriversStore';

import { 
    sendLines,
    sendMetrosTotalRota 
} from '../../channels/linesChannel';
import { useLinesStore } from '../../stores/useLinesStore';

import {
    sendTurnos,
    sendTurnosCodes
} from '../../channels/turnosChannel';
import { useTurnosStore } from '../../stores/useTurnosStore';

import { sendTrips } from '../../channels/tripsChannel';
import { useTripsStore } from '../../stores/useTripsStore';

import { openFiltersWindow, closeFiltersWindow } from '../../utils/filtersWindow';
import { useScreenStore } from '../../stores/useScreenStore';
import { useAuthStore } from '../../stores/useAuthStore';
import { useToast } from '../toast/useToast';
import { useLoadingStore } from '../../stores/useLoadingStore';

import { useTripAlertsAnalysisStore } from '../../stores/analysis/useTripAlertsAnalysisStore';
import { sendAlertsBatch } from '../../channels/tripAlertsAnalysisChannel';

import { useTripStatusAnalysisStore } from '../../stores/analysis/useTripStatusAnalysisStore';
import { sendStatusBatch } from '../../channels/tripStatusAnalysisChannel';

import { useTripPositionsAnalysisStore } from '../../stores/analysis/useTripPositionsAnalysisStore';
import { sendPositionsBatch } from '../../channels/tripPositionsAnalysisChannel';

import { useTripFiltersStore } from '../../stores/useTripFiltersStore';
import { sendSituacoes, sendDesempenho } from '../../channels/tripsChannel';

import { sendHourRange } from '../../channels/hourRangeChannel';

import { useHourFilterStore } from '../../stores/useHourFilterStore';
import { useDateStore } from '../../stores/useDateStore';

import { useOperationalMapStore } from '../../stores/useOperationalMapStore';
import { sendOperationalMapMode, sendOperationalMapDateRange } from '../../channels/operationalMapChannel';

import { usePontosItinerarioStore } from '../../stores/usePontosItinerarioStore';

import { useTripOccurrencesStore } from '../../stores/useTripOccurrencesStore';

export function useHomeChannel() {

    const { warning } = useToast();    

    useEffect(() => {

        const unsubscribe = listenMonitor(({ tipo }) => {

            if (tipo === 'request-initial-data') {

                sendInitialDataStart();

                const {
                    isOperationalMapMode,
                    operationalMapDateRange
                } = useOperationalMapStore.getState();

                sendOperationalMapMode(isOperationalMapMode);

                sendOperationalMapDateRange({
                    startDate:
                        operationalMapDateRange
                            .startDate
                            .format('YYYY-MM-DD'),

                    endDate:
                        operationalMapDateRange
                            .endDate
                            .format('YYYY-MM-DD')
                });

                sendClients(
                    useClientsStore
                        .getState()
                        .clientesDisponiveis
                );

                sendVehicles(
                    useVehiclesStore
                        .getState()
                        .veiculosDisponiveis
                );

                sendDrivers(
                    useDriversStore
                        .getState()
                        .driversDisponiveis
                );
             
                sendLines(
                    useLinesStore
                        .getState()
                        .linhasDisponiveis
                );

                sendMetrosTotalRota(
                    useLinesStore
                        .getState()
                        .exportMetrosTotalRota()
                );

                sendTurnos(
                    useTurnosStore
                        .getState()
                        .turnos
                );

                sendTurnosCodes(
                    useTurnosStore
                        .getState()
                        .turnosCodes
                )

                sendTrips(
                    [...useTripsStore.getState().tripsMap.values()]
                );

                sendSituacoes(
                    useTripFiltersStore
                        .getState()
                        .situacoesSelecionadas
                );

                sendDesempenho(
                    useTripFiltersStore
                        .getState()
                        .desempenhosSelecionados
                );
                
                usePontosItinerarioStore
                    .getState()
                    .sendPontosSnapshot();

                useTripOccurrencesStore
                    .getState()
                    .sendOccurrencesSnapshot();

            }

            if(tipo === 'trips-initialized') {
                sendVehiclesSelectedTrips(
                    useVehiclesStore
                        .getState()
                        .veiculosEmViagemSelecionados
                );

                sendDriversSelectedTrips(
                    useDriversStore
                        .getState()
                        .driversEmViagemSelecionados
                );

                sendAlertsBatch(
                    useTripAlertsAnalysisStore
                        .getState()
                        .exportAlerts()
                );

                sendStatusBatch(
                    useTripStatusAnalysisStore
                        .getState()
                        .exportStatus()
                );

                sendPositionsBatch(
                    useTripPositionsAnalysisStore
                        .getState()
                        .exportPositions()
                )
                
                setTimeout(() => {
                    sendInitialDataDone();
                    useLoadingStore
                        .getState()
                        .stopLoading(false);
                }, 1000);
            }

            if (tipo === 'filters-closed') {

                closeFiltersWindow();
                const { monitorMode } = useScreenStore.getState();
                const { user } = useAuthStore.getState();

                if (monitorMode !== 2 || !user) {
                    useLoadingStore
                        .getState()
                        .stopLoading(false);
                    return;
                }

                useLoadingStore
                    .getState()
                    .startLoading('Reabrindo a tela de filtros...', false);

                
                setTimeout(() => {

                    const winOpened = openFiltersWindow();

                    if (!winOpened) {

                        warning('Não foi possível reabrir automaticamente a tela de filtros. O sistema voltará para o modo de monitoramento em uma única tela.');
                        useScreenStore
                            .getState()
                            .setMonitorMode(1);

                        useLoadingStore
                            .getState()
                            .stopLoading(false);

                    }
                    
                }, 1000);

            }

            if(tipo === 'request-hour-range'){
                const payload = {
                    hourRange: useHourFilterStore.getState().hourRange,
                    manual: !useDateStore.getState().autoOperationalRange,
                    initialSync: true
                }
                sendHourRange(payload);
            }

        });

        return unsubscribe;

    }, [warning]);

    useEffect(() => {
    
        const handleUnload = () => {

            closeFiltersWindow();

        };

        window.addEventListener(
            'beforeunload',
            handleUnload
        );

        return () => {

            window.removeEventListener(
            'beforeunload',
            handleUnload
            );

        };

    }, []);

}